import script from "./AddToAlbumModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddToAlbumModal.vue?vue&type=script&setup=true&lang=ts"

import "./AddToAlbumModal.vue?vue&type=style&index=0&id=2667350f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2667350f"]])

export default __exports__